// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__28cxH","buttons":"PendingPaymentAlert_buttons__3GJqZ"};